export const messages = {
  modal: {
    title: {
      id: 'admin/promotions.form.review.title',
    },
    cancel: {
      id: 'admin/promotions.utils.cancel',
    },
    confirm: {
      id: 'admin/promotions.form.confirm',
    },
    holdToSave: {
      id: 'admin/promotions.form.hold-to-save',
    },
  },
}
